import { render, staticRenderFns } from "./licai.vue?vue&type=template&id=e9d5ba4a&scoped=true&"
import script from "./licai.vue?vue&type=script&lang=js&"
export * from "./licai.vue?vue&type=script&lang=js&"
import style0 from "./licai.vue?vue&type=style&index=0&id=e9d5ba4a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d5ba4a",
  null
  
)

export default component.exports